<template>
    <div>

        <vue-headful title="User Management :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-sitemap"></i> API Users</li>
                <li class="ml-3">
                    <router-link :to="`/admin/api-users/edit`" class="btn btn-sm btn-success"><i class="fa fa-plus-circle"></i> Create API User</router-link>
                </li>
            </ol>
        </h4>

        <div class="alert alert-info">
            <strong>Documentation:</strong> Please read the documentation to get started using API Users.
            <a href="/api/docs" class="btn btn-info mt-2">Go To API Documentation</a>
        </div>

        <div class="card">
            <div class="card-body">
                <v-server-table ref="userTable" url="/admin/api-users" :columns="columns" :options="options">

                    <router-link slot="UserId" slot-scope="props" :to="`/admin/api-users/view/${props.row.UserId}`" :title="`View ${props.row.FirstName}`" class="btn btn-xs btn-secondary">
                        View
                    </router-link>

                    <template slot="FirstName" slot-scope="props">
                        <router-link :to="`/admin/api-users/view/${props.row.UserId}`" :title="`View ${props.row.FirstName}`">
                            {{ props.row.FirstName }}
                        </router-link>
                    </template>

                    <template slot="LastLoginDate" slot-scope="props">
                        {{ props.row.LastLoginDate | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}
                    </template>

                    <template slot="IsActive" slot-scope="props">
                        <span class="badge badge-success" v-if="props.row.IsActive == 1">Active</span>
                        <span class="badge badge-warning" v-else>Inactive</span>
                    </template>

                </v-server-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                getDeleted: false,
                userTimezone: this.$store.state.user.timezone,
                columns: ['UserId', 'FirstName', 'IsActive'],
                options: {
                    headings: {
                        UserId: 'ID',
                        FirstName: 'Name',
                        IsActive: 'Active Status',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'user.FirstName',
                    },
                    requestAdapter: (data) => {
                        // //How do we get the filters
                        // data.filters = this.$store.state.tableFilters.incidentFilters;

                        // //Parse the filters
                        // //data.filters['incident.IncidentTypeId'] = [];

                        // //console.log(this.$store.state.tableFilters.incidentFilters['incident.IncidentTypeId']);

                        // for(var i = 0; i <= this.$store.state.tableFilters.incidentFilters['incident.IncidentTypeId'].length; i++)
                        // {
                        //     //Add each id
                        //     //data.filters['incident.IncidentTypeId'].push(this.$store.state.tableFilters.incidentFilters['incident.IncidentTypeId'][i]['id']);
                        // }

                        //Send it
                        return data;
                    },
                    uniqueKey: 'UserId',
                },
            }
        },

        methods: {

        },
    }
</script>
